import type { MediaAccessErrorDOMExceptionSubType } from '@openphone/desktop-client'

export function mapDOMExceptionToUMDAPlatformErrorSubType(
  error: DOMException,
): MediaAccessErrorDOMExceptionSubType {
  switch (error.name) {
    case 'NotAllowedError':
      return 'not-allowed'
    case 'SecurityError':
      return 'security'
    case 'NotReadableError':
      return 'not-readable'
    case 'NotFoundError':
      return 'not-found'
    case 'DevicesNotFoundError':
      return 'not-found'
    case 'OverconstrainedError':
      return 'overconstrained'
    case 'TypeError':
      return 'type-error'
    default:
      return 'unknown'
  }
}
